import React, { useEffect, useState } from "react";
import { Button, Collapse } from "react-bootstrap";
import { useSelector } from "react-redux";
import AwesomeIcon from "@icons/AwesomeIcon";
import { RootState } from "@/types/RootState";

interface SntCollapseProps {
  children: React.ReactNode;
  isDisableCollapseOnMobile?: boolean;
}

export const SntCollapse: React.FC<SntCollapseProps> = ({
  children,
  isDisableCollapseOnMobile = false,
}) => {
  const { isMobile } = useSelector((state: RootState) => state.all);
  const [open, setOpen] = useState<boolean>(
    isDisableCollapseOnMobile ? true : !isMobile
  );

  useEffect(() => {
    setOpen(isDisableCollapseOnMobile ? true : !isMobile);
  }, [isMobile, isDisableCollapseOnMobile]);

  return (
    <>
      {isMobile && !isDisableCollapseOnMobile && (
        <Button
          variant="sensolus-greylight"
          onClick={() => setOpen(!open)}
          aria-expanded={open}
          className="mb-2"
        >
          <AwesomeIcon icon="filter"></AwesomeIcon>
        </Button>
      )}
      <Collapse in={open}>
        <div>{children}</div>
      </Collapse>
    </>
  );
};
